export const PACKAGE_NAME = '@atlassian/jira-end-of-trial-message-shared-global-component';
export const TEAM_NAME = 'transmuters-growth';
export const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;
